<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PA12"></a><a id="GBS.PA12.w.0.0.0"></a></div>
<div class="flow" style="">
<a class="page" id="ORIG-GBS.PA11"></a>
<div class="gtxt_body" id="block.12.0.0.box.827.574.549.102.q.80">
<a id="ORIG-GBS.PA11.w.0.0.0"></a><p class="gtxt_body gtxt_heading" id="para.12.0.0.box.827.574.549.102.q.80" style="font-variant:small-caps;">Part I: Crabs</p>
</div>
</div><div style="display:none;"><a id="GBS.PA13"></a><a id="GBS.PA13.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PA13.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PA13.w.0.0.0.2"></a></div><div class="flow" style="">
</div>
<div style="display:none;"><a id="GBS.PA13.w.0.0.0.3"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content0007.vue?a11756d8